import IndexSPA from "./IndexSPA.jsx"

export default IndexSPA
